/**
 * Script scaricato da questa guida
 * https://guida.feedaty.com/article/93-installazione-modulo-q-a
 */

jQuery(document).ready(function () {

    var _me = this,
        configuration = {
            script: false,
            head: false
        },
        pendingLocale = [],
        pendingTemplate = {},
        settings = {
            version: "0.3.1.0",
            productionPath: "https://ai.feedaty.com",
            stagePath: location.protocol + "//" + window.location.host,
            cssPathStyle1: "/qni/Content/qa_v1.css",
            cssPathStyle2: "/qni/Content/qa_v2.css",
            apiPath: "/qni/",
            templatesPath: "/qni/Templates/2022/",
            timeoutThanks: 900
        },
        templates = {},
        locale,
        customLocale = null;

    function initQa() {

        var script = document.getElementById("qa-script"),
            data = script.dataset,
            cssStyle = "",
            host = settings.productionPath;

        if (!data)
            data = {};

        if (!configuration.head) {
            customLocale = data.qaLocalization;

            if (data.qaStage) {
                if (data.qaServer)
                    host = data.qaServer;
                else
                    host = settings.stagePath;
            }

            if (data.qaCssStyle && data.qaCssStyle == '2')
                cssStyle = host + settings.cssPathStyle2;
            else
                cssStyle = host + settings.cssPathStyle1;

            configuration.head = true;
            settings.apiPath = host + settings.apiPath;
            settings.templatesPath = host + settings.templatesPath;

            var link1 = document.createElement('link');
            link1.rel = 'stylesheet';
            link1.type = 'text/css';
            link1.href = cssStyle;
            document.head.appendChild(link1);

            if (data.qaCss) {
                var link2 = document.createElement('link');
                link2.rel = 'stylesheet';
                link2.type = 'text/css';
                link2.href = data.qaCss;
                document.head.appendChild(link2);
            }
        }

        document.querySelectorAll(".qaQuestion").forEach(function (element) {
            if (element.dataset.qainit)
                return;

            element.dataset.qainit = true;

            new _me.Question(element);
        });

        document.querySelectorAll(".qaQuestions").forEach(function (element) {
            if (element.dataset.qainit)
                return;

            element.dataset.qainit = true;
            new _me.Questions(element);
        });

    }

    function localize(src) {
        var div = document.createElement('div');
        div.innerHTML = src;
        div.querySelectorAll("[data-qa-locale]").forEach(function (element) {
            var key = element.getAttribute("data-qa-locale");
            if (locale[key]) {
                element.innerHTML = locale[key];
                element.removeAttribute("data-qa-locale");
            }
        });
        div.querySelectorAll("[data-qa-placeholder]").forEach(function (element) {
            var key = element.getAttribute("data-qa-placeholder");
            if (locale[key]) {
                element.setAttribute("placeholder", locale[key]);
                element.removeAttribute("data-qa-placeholder");
            }
        });
        return div.innerHTML;
    }

    function getFormData(form) {
        var data = {};
        form.querySelectorAll("input,textarea,select").forEach(function (element) {
            data[element.name] = element.value;
        });
        return data;
    }

    function getTemplate(name, callback) {
        if (templates[name]) {
            if (callback)
                callback.apply(_me, [templates[name]]);
        } else {
            if (pendingTemplate[name]) {
                if (callback)
                    pendingTemplate[name].push(callback);
            } else {
                if (callback)
                    pendingTemplate[name] = [callback];
                fetch(settings.templatesPath + name + ".html")
                    .then(response => response.text())
                    .then(data => {
                        templates[name] = localize(data);
                        while (pendingTemplate[name].length)
                            pendingTemplate[name].shift().apply(_me, [templates[name]]);
                    });
            }
        }
    }

    function fillTemplateFields(dst, data) {
        dst.querySelectorAll("[data-qa-field]").forEach(function (element) {
            element.textContent = data[element.getAttribute("data-qa-field")];
            element.removeAttribute("data-qa-field");
        });
        return dst;
    }

    function elementFromTextWithData(text, data) {
        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = text;
        let element = fillTemplateFields(tempDiv.firstChild, data);
        return element;
    }

    function getTemplates(names, callback) {
        var pending = names.length;
        names.forEach(function (name) {
            getTemplate(name, function () {
                pending--;
                if (!pending && callback)
                    callback.apply(_me, [null]);
            });
        });
    }

    function waitLocale(callback) {
        if (!locale) {
            pendingLocale.push(callback);
            if (pendingLocale.length === 1)
                api("locale", null, null, function (data) {

                    if (customLocale) {
                        fetch(customLocale)
                            .then(response => response.json())
                            .then(data2 => {
                                locale = Object.assign(data, data2);
                                while (pendingLocale.length)
                                    pendingLocale.shift().apply(_me, [null]);
                            })
                            .catch(() => {
                                locale = data;
                                while (pendingLocale.length)
                                    pendingLocale.shift().apply(_me, [null]);
                            });
                    } else {
                        locale = data;
                        while (pendingLocale.length)
                            pendingLocale.shift().apply(_me, [null]);
                    }

                }, function (data) {
                    document.querySelectorAll(".qa").forEach(function (element) {
                        element.classList.add("qaError");
                    });
                });
        } else {
            callback.apply(_me, [null]);
        }
    }

    function api(name, data, method, successCB, errorCB) {
        let bodyData = JSON.stringify(data);

        if (data == null) {
            bodyData = null;
        }

        if (!method) {
            method = "GET";
        }

        fetch(settings.apiPath + name, {
            method: method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: bodyData
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    if (errorCB) {
                        errorCB.apply(_me, [data.error]);
                    }
                } else {
                    if (successCB) {
                        successCB.apply(_me, [data]);
                    }
                }
            })
            .catch(error => {
                if (errorCB) {
                    errorCB.apply(_me, [error]);
                }
            });
    }


    function loadCfg(idm, idp, callback, errorHandler) {
        api("config", {
            idMerchant: idm,
            idProduct: idp
        },"POST", callback, errorHandler);
    }

    function clearValidationErrors(dst) {
        dst.querySelectorAll("span.qaValError").forEach(function (element) {
            element.style.display = 'none';
        });
    }

    function setValidationError(dst, data) {
        if (typeof data === 'object' && !Array.isArray(data)) {
            Object.keys(data).forEach(function (key) {
                var inp = dst.querySelector('[name="' + key + '"]');
                var valSpan = inp ? inp.previousElementSibling : dst.lastElementChild;
                if (!valSpan.classList.contains("qaValError") || valSpan.tagName === "span") {
                    valSpan = document.createElement('span');
                    valSpan.classList.add("qaValError");
                    if (inp) {
                        inp.before(valSpan);
                    } else {
                        dst.appendChild(valSpan);
                    }
                }
                valSpan.innerHTML = Array.isArray(data[key]) ? data[key].map(function (err) {
                    return locale[err] || err;
                }).join('<br/>') : locale.UnhandledError;
                valSpan.style.display = 'block';
            });
        } else {
            var valSpan = dst.lastElementChild;
            if (!valSpan.classList.contains("qaValError") || valSpan.tagName === "span") {
                valSpan = document.createElement('span');
                valSpan.classList.add("qaValError");
                dst.appendChild(valSpan);
                valSpan.innerHTML = locale.UnhandledError;
                valSpan.style.display = 'block';
            }
        }
    }

    function fadeOut(element, durationOrCallback, callback) {
        let duration = 250; // Default duration

        if (typeof durationOrCallback === 'function') {
            callback = durationOrCallback; // Se il secondo parametro è una funzione, è la callback
        } else if (typeof durationOrCallback === 'number') {
            duration = durationOrCallback; // Se è un numero, è la durata
        }

        const opacity = element.style.opacity;

        element.style.transition = `opacity ${duration}ms`;
        element.style.opacity = 0;

        setTimeout(() => {
            element.style.display = 'none';
            element.style.opacity = opacity;

            if (typeof callback === "function") {
                callback();
            }
        }, duration);
    }

    function fadeIn(element, durationOrCallback, callback) {
        let duration = 250; // Default duration

        if (typeof durationOrCallback === 'function') {
            callback = durationOrCallback;
        } else if (typeof durationOrCallback === 'number') {
            duration = durationOrCallback;
        }

        const opacity = element.style.opacity;

        element.style.display = 'block';
        element.style.opacity = 0;
        element.style.transition = `opacity ${duration}ms`;

        setTimeout(() => {
            element.style.opacity = opacity;
        }, 10);

        setTimeout(() => {
            if (typeof callback === "function") {
                callback();
            }
        }, duration);
    }

    function getOriginalHeight(element) {
        // Controlla se c'è un'altezza definita via CSS


        return height;

        //// Verifica se l'altezza è diversa da '0px' o 'auto'
        //if (height !== '0px' && height !== 'auto') {
        //    return height;
        //} else {
        //    // Se l'altezza non è specificata, calcola quella reale temporaneamente
        //    element.style.display = 'block';
        //    const actualHeight = `${element.offsetHeight}px`;
        //    element.style.display = 'none';
        //    return actualHeight;
        //}
    }

    function generateJsonLdForQA(questionsResponse) {
        const { records } = questionsResponse;

        // Definisci la lunghezza massima per il campo "name"
        const MAX_NAME_LENGTH = 50;

        // Crea il JSON-LD
        const jsonLd = {
            "@context": "https://schema.org",
            "@type": "QAPage",
            "mainEntity": records.map(question => ({
                "@type": "Question",
                "name": question.Question.length > MAX_NAME_LENGTH
                    ? question.Question.substring(0, MAX_NAME_LENGTH - 3) + "..."
                    : question.Question,
                "text": question.Question, // Testo completo
                "dateCreated": question.Date,
                "author": {
                    "@type": "Person",
                    "name": question.Customer
                },
                "answerCount": question.Answers.length,
                "suggestedAnswer": question.Answers.map(answer => ({
                    "@type": "Answer",
                    "text": answer.Answer,
                    "dateCreated": answer.Date,
                    "author": {
                        "@type": answer.FromMerchant ? "Organization" : "Person",
                        "name": answer.Customer
                    }
                }))
            }))
        };

        // Trova il blocco JSON-LD del widget, se esiste
        let script = document.querySelector('script[data-widget="qaJsonLD"]');
        if (!script) {
            // Crea un nuovo script JSON-LD per il widget
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.setAttribute("data-widget", "qaJsonLD"); // Identificatore univoco
            document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(jsonLd, null, 2);
    }


    _me.Question = function (dst) {
        let _me = this,
            idMerchant = dst.dataset.idmerchant,
            idProduct = dst.dataset.idproduct,
            productName = dst.dataset.productname,
            productBrand = dst.dataset.productbrand,
            productUrl = dst.dataset.producturl,
            recaptcha = {
                key: '6LdAYuYUAAAAAJkb0bx7MgSVL1v2hFIWYXBFx3RX',
                enabled: true,
                token: null,
                load: false,
                readyForInit: false,
                interval: null
            },
            reshow = {
                count: 0,
                interval: null,
                bar: null
            },
            modal = {},
            modalBackdrop = {},
            btnQuestion = {},
            thanksNote = {},
            questionCard = {},
            btnSubmit = {},
            showForm = !dst.dataset.hideform;

        dst.classList.add("qa", "qaLoading");
        dst.textContent = "...";

        loadCfg(idMerchant, idProduct, function (cfg) {
            if (cfg.enabled) {
                showForm = cfg.showForm !== null ? cfg.showForm : showForm;
                if (recaptcha.enabled) {
                    var script = document.createElement('script');
                    script.src = "https://www.google.com/recaptcha/api.js?render=" + recaptcha.key;
                    document.body.appendChild(script);
                    recaptcha.interval = setInterval(initRecaptcha, 100);
                }
                waitLocale(function () {
                    getTemplates(["QuestionModal", "QuestionForm"], init);
                });
            } else {
                dst.classList.remove("qaLoading");
                dst.textContent = "";
            }
        });

        function initRecaptcha() {
            if (typeof grecaptcha !== 'undefined' && grecaptcha.render && recaptcha.readyForInit) {
                clearInterval(recaptcha.interval);
                recaptcha.load = true;
            }
        }

        function reshowQuestion() {
            reshow.count++;
            reshow.bar.style.width = (reshow.count * 100 / settings.timeoutThanks) + '%';
            if (reshow.count === settings.timeoutThanks) {
                fadeOut(thanksNote);
                fadeIn(questionCard);
                clearInterval(reshow.interval);
            }
        }

        function submit() {
            clearValidationErrors(modal);
            var d = getFormData(modal);
            d.idMerchant = idMerchant;
            d.idProduct = idProduct;
            d.productName = productName;
            d.productBrand = productBrand;
            d.productUrl = productUrl || document.URL;
            d.version = settings.version;

            if (recaptcha.enabled) {
                if (recaptcha.token === null) {
                    setValidationError(modal, { "recapatcha": [locale.reCaptchaError] });
                    return;
                } else {
                    d.recaptchaToken = recaptcha.token;
                }
            }

            api("QuestionNew", d, "POST",
                function (data) {
                    modal.querySelector("textarea[name=Question]").value = "";
                    questionCard.style.display = 'none';
                    thanksNote.style.display = 'block';
                    thanksNote.querySelector("span").textContent = locale[data.message];
                    modal.style.display = 'none';
                    modalBackdrop.style.display = 'none';
                    document.body.removeChild(modalBackdrop);
                    modal.classList.remove("in");
                    if (recaptcha.enabled) {
                        recaptcha.token = null;
                    }
                    reshow.count = 0;
                    reshow.interval = setInterval(reshowQuestion, 10);
                },
                function (data) {
                    setValidationError(modal, data);
                    btnSubmit.disabled = false;
                    fadeIn(btnSubmit);
                }, function () {
                    btnSubmit.disabled = false;
                    fadeIn(btnSubmit);
                    return true;
                });
        }

        function init() {
            dst.innerHTML = localize(templates["QuestionForm"]);

            var modalHTML = localize(templates["QuestionModal"]);
            var modalDiv = document.createElement('div');
            modalDiv.innerHTML = modalHTML;
            document.body.appendChild(modalDiv);

            modal = modalDiv.querySelector(".qaModal");
            btnSubmit = modalDiv.querySelector("button.qaAccept");
            btnQuestion = dst.querySelector("button.qaModalOn");
            questionCard = dst.querySelector(".qaQuestionCard");
            thanksNote = dst.querySelector(".qaThanks");

            btnQuestion.addEventListener("click", function (event) {
                event.preventDefault();

                modal.classList.add("in");
                fadeIn(modal);
                modalBackdrop = document.createElement('div');
                modalBackdrop.classList.add('qaModal-backdrop');
                document.body.appendChild(modalBackdrop);
                fadeIn(modalBackdrop);

                modalBackdrop.addEventListener("click", function () {
                    fadeOut(modal);
                    fadeOut(modalBackdrop, () => {
                        document.body.removeChild(modalBackdrop);
                        modal.classList.remove("in");
                    });

                });
                modal.querySelector("form:first-of-type").style.display = 'block';
                modal.querySelector("textarea[name=Question]").focus();
            });

            var noteLink = modalDiv.querySelector(".qaNote");
            var noteDetails = modalDiv.querySelector(".qaNoteDetails");

            noteLink.addEventListener("click", function (event) {
                event.preventDefault();
                noteLink.classList.toggle("collapsed");
                noteDetails.classList.toggle("in");
            });

            var btnClose = modalDiv.querySelector("button.qaClose");

            btnClose.addEventListener("click", function (event) {
                event.preventDefault();
                fadeOut(modal);
                fadeOut(modalBackdrop, () => {
                    document.body.removeChild(modalBackdrop);
                    modal.classList.remove("in");
                });
            });

            btnSubmit.addEventListener("click", function (event) {
                event.preventDefault();
                btnSubmit.disabled = true;
                fadeOut(btnSubmit);

                if (recaptcha.enabled) {
                    if (grecaptcha && grecaptcha.execute)
                        grecaptcha.execute(recaptcha.key, { action: 'homepage' }).then(function (token) { recaptcha.token = token; submit(); });
                    else {
                        setValidationError(modal, { "recapatcha": [locale.reCaptchaError] });

                        btnSubmit.disabled = false;
                        fadeIn(btnSubmit);
                    }
                }
                else {
                    submit();
                }
            });

            reshow.bar = dst.querySelector('.qaBar').children[0];

            dst.classList.remove("qaLoading");
            recaptcha.readyForInit = true;
        }
    };

    _me.Questions = function (dst) {
        var _me = this,
            idMerchant = dst.dataset.idmerchant,
            idProduct = dst.dataset.idproduct,
            ul = null,
            nextBtt = null,
            logo = "",
            nextRecordNumber = 1;

        if (dst.dataset.token) return;

        dst.classList.add("qa", "qaLoading");
        dst.textContent = "...";

        function errorHandler() {
            dst.classList.remove("qaLoading");
            dst.classList.add("qaError");
        }

        loadCfg(idMerchant, idProduct, function (cfg) {
            if (cfg.enabled) {
                logo = cfg.LogoUrl;
                waitLocale(function () {
                    getTemplates(["QuestionsPanel", "QuestionItem", "AnswerItem"], init);
                });
            } else {
                dst.classList.remove("qaLoading");
                dst.textContent = "";
            }
        }, errorHandler);

        function init() {
            api("Questions", {
                idMerchant: idMerchant,
                idProduct: idProduct,
                firstRecord: nextRecordNumber
            },"POST", function (data) {
                if (!ul) {
                    dst.classList.remove("qaLoading");
                    dst.innerHTML = templates.QuestionsPanel;
                    ul = dst.querySelector("ul:first-of-type");
                    nextBtt = dst.querySelector(".qaNextResults");
                    nextBtt.addEventListener("click", function (event) {
                        event.preventDefault();
                        nextBtt.style.display = 'none';
                        dst.querySelector(".qaLoading").style.display = 'block';
                        init();
                    });
                } else {
                    dst.querySelector(".qaLoading").style.display = 'none';
                }
                nextRecordNumber = data.firstRecord + data.records.length;

                generateJsonLdForQA(data);

                while (data.records.length) {
                    let q = data.records.shift();

                    let qElement = elementFromTextWithData(templates["QuestionItem"], q);
                    let saveBtts = qElement.querySelectorAll(".qaAccept");
                    saveBtts.forEach(btt => btt.remove());

                    let aElement = qElement.querySelector(".qaAnswers");

                    if (q.Answers.length !== 0) {
                        let i = 0;
                        while (q.Answers.length) {
                            let a = q.Answers.shift();
                            let answerElement = elementFromTextWithData(templates["AnswerItem"], a);
                            if (a.FromMerchant) {
                                answerElement.classList.add("qaFromMerchant");
                                answerElement.querySelector(".qaAnswerProfileImg").style.backgroundImage = "url(" + logo + ")";
                            }

                            let btShowMore = answerElement.querySelector(".qaShowMoreReplies");
                            let btShowLess = answerElement.querySelector(".qaShowLessReplies");

                            if (i === 0) {
                                if (q.Answers.length === 0) {
                                    btShowMore.remove();
                                    btShowLess.remove();
                                }
                                else {
                                    btShowLess.remove();
                                    btShowMore.querySelector(".qaReplyCount").textContent = " (" + q.Answers.length + ")";
                                    btShowMore.addEventListener("click", function (event) {
                                        event.preventDefault();
                                        fadeOut(this, 100, () => {
                                            this.closest("ul").querySelectorAll("li").forEach(function (li) {
                                                fadeIn(li);
                                            });
                                        });

                                    });
                                }
                            }
                            if (i > 0) {
                                answerElement.style.display = 'none';
                                btShowMore.remove();
                                if (q.Answers.length) {
                                    btShowLess.remove();
                                }
                                else {
                                    btShowLess.addEventListener("click", function (event) {
                                        event.preventDefault();
                                        var li = this.closest("ul").querySelectorAll("li");
                                        fadeIn(li[0].querySelector(".qaShowMoreReplies"));
                                        for (var j = 1; j < li.length; j++) {
                                            fadeOut(li[j]);
                                        }
                                    });
                                }
                            }
                            i++;

                            aElement.appendChild(answerElement);
                        }
                    }


                    ul.appendChild(qElement);
                    fadeIn(qElement);
                }
                if (data.totalRecords >= nextRecordNumber) {
                    nextBtt.querySelector("span:last-of-type").textContent = " (" + (data.totalRecords - nextRecordNumber + 1) + ")";
                    nextBtt.style.display = '';
                }

            }, errorHandler);
        }
    };

    initQa();

    document.addEventListener("DOMContentLoaded", function () {
        // initQa();
    });

    globalThis.feedatyQaInit = initQa;

});